import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './personal_allysoncavalcante_consultoria.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5511986487976';
const WHATSAPP_MSG_CONSULTORIA =
    'Olá! Vi a página da consultoria online e quero entender qual plano combina mais comigo. Podemos conversar?';

const whatsappConsultoriaLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG_CONSULTORIA)}`;

const GALLERY_ITEMS: { src: string; label: string }[] = [
    // { src: require('./src/consultoria/consultoria1.png'), label: 'Consultoria 1' },
    // { src: require('./src/consultoria/consultoria2.png'), label: 'Consultoria 2' },
    // { src: require('./src/consultoria/consultoria3.png'), label: 'Consultoria 3' },
    // { src: require('./src/consultoria/consultoria4.png'), label: 'Consultoria 4' },
    // { src: require('./src/consultoria/consultoria5.png'), label: 'Consultoria 5' },
    // { src: require('./src/consultoria/consultoria6.png'), label: 'Planos e valores' },
];

const Personal_allysoncavalcante_consultoria: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.personal_allysoncavalcante_consultoria}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/personal_allysoncavalcante"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Personal Allyson Cavalcante</p>
                        <h1 className={styles.title}>Consultoria fitness online</h1>
                    </div>
                </div>

                <p className={styles.intro}>
                    Tenha um treino montado com estratégia, acompanhamento e suporte direto para evoluir com mais segurança,
                    consistência e resultado. Escolha o plano ideal para o seu momento e comece agora.
                </p>

                {GALLERY_ITEMS.length > 0 && (
                    <div className={styles.grid}>
                        {GALLERY_ITEMS.map((item, index) => (
                            <figure key={item.src} className={styles.card}>
                                <img
                                    src={item.src}
                                    alt={`Consultoria online — ${item.label}`}
                                    className={styles.cardImage}
                                    loading={index < 2 ? 'eager' : 'lazy'}
                                />
                                <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                            </figure>
                        ))}
                    </div>
                )}

                <div className={styles.pricingSection} aria-labelledby="planos-heading">
                    <h2 id="planos-heading" className={styles.pricingTitle}>
                        Escolha seu plano e acelere seus resultados
                    </h2>

                    <div className={styles.planCard}>
                        <p className={styles.planName}>Plano 2 meses</p>
                        <p className={styles.planPeriod}>Ideal para quem quer começar com foco e organização</p>
                        <p className={styles.planPrice}>
                            <strong>Investimento:</strong> R$ 250,00
                        </p>
                        <ul className={styles.planDetails}>
                            <li>Treino montado de acordo com seu objetivo e rotina.</li>
                            <li>Acompanhamento próximo para manter constância e evolução.</li>
                        </ul>
                    </div>

                    <div className={styles.planCard}>
                        <p className={styles.planName}>Plano trimestral</p>
                        <p className={styles.planPeriod}>Mais tempo de acompanhamento para construir resultado real</p>
                        <p className={styles.planPrice}>
                            <strong>Investimento:</strong> R$ 550,00
                        </p>
                        <ul className={styles.planDetails}>
                            <li>Mais tempo para ajustar o treino e consolidar a evolução.</li>
                            <li>Melhor opção para quem quer levar o processo com mais profundidade.</li>
                        </ul>
                    </div>

                    <div className={styles.dailyBox}>
                        <p className={styles.dailyTitle}>Como funciona sua consultoria</p>
                        <p className={styles.dailyText}>
                            Seu treino é entregue por aplicativo, com visualização de vídeos demonstrando a execução dos
                            movimentos para facilitar a prática e aumentar sua confiança na hora de treinar.
                        </p>
                        <ul className={styles.dailyList}>
                            <li>
                                Você recebe orientação pensada para o seu objetivo, não um treino genérico.
                            </li>
                            <li>
                                Os vídeos no app mostram como realizar os movimentos com mais clareza.
                            </li>
                            <li>
                                Sempre que surgirem dúvidas, o Allyson estará disponível para orientar você.
                            </li>
                        </ul>
                        <p className={styles.dailyHighlight}>
                            Em vez de perder tempo testando sozinho, você começa com direção, acompanhamento e mais chance
                            de resultado.
                        </p>
                    </div>
                </div>

                <div className={styles.infoSection}>
                    <div className={styles.infoCard}>
                        <h2 className={styles.infoTitle}>O que preciso enviar para começar?</h2>
                        <p className={styles.infoLead}>
                            Para montar seu plano com mais precisão, o cadastro começa com algumas informações simples:
                        </p>
                        <ul className={styles.infoList}>
                            <li>
                                <strong>Fotos do corpo:</strong> frente, lados e costas.
                            </li>
                            <li>
                                <strong>Homens:</strong> fotos de sunga.
                            </li>
                            <li>
                                <strong>Mulheres:</strong> top de alças finas e shorts curto.
                            </li>
                            <li>
                                <strong>Cadastro no app:</strong> e-mail, data de nascimento e telefone.
                            </li>
                            <li>
                                Se houver qualquer dúvida sobre as fotos, o padrão de envio será encaminhado.
                            </li>
                        </ul>
                    </div>
                </div>

                <p className={styles.footerNote}>
                    Quanto antes você enviar seus dados, mais rápido o cadastro é liberado no app e o planejamento do seu
                    treino pode começar.
                </p>

                <div className={styles.ctaSection} aria-labelledby="cta-consultoria-heading">
                    <h2 id="cta-consultoria-heading" className={styles.ctaHeading}>
                        Clique no WhatsApp e dê o primeiro passo hoje
                    </h2>
                    <p className={styles.ctaText}>
                        Fale agora com o Allyson, descubra qual plano combina mais com você e receba as orientações para
                        iniciar sua consultoria o quanto antes.
                    </p>
                    <a
                        href={whatsappConsultoriaLink}
                        className={styles.ctaWhatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#ffffff" />
                        <span>Falar no WhatsApp agora</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Personal_allysoncavalcante_consultoria;
